import React, { useEffect, useState } from 'react';

import { GOOGLE_MAP_ID } from '../utils/Config';
import { Map, useMap } from '@vis.gl/react-google-maps';
import { Polygon } from '../utils/Types';
import {
  clearAddedPolygon,
  updatePolygonAndMap,
} from '../pages/assign-grid/AssignGridHelper';

interface IGridMapProps {
  polygonPositionsArray: any[] | undefined;
}

const defaultPosition = { lat: 17.38405, lng: 78.45636 };

const GridMap: React.FunctionComponent<IGridMapProps> = ({
  polygonPositionsArray,
}) => {
  const mapInstance = useMap();
  const [addedPolygon, setAddedPolygon] = useState<Polygon[]>();

  useEffect(() => {
    clearAddedPolygon(mapInstance, addedPolygon);
    if (
      !mapInstance ||
      !polygonPositionsArray ||
      polygonPositionsArray.length === 0
    )
      return;
    // Construct the polygon.
    const polygonArray: Polygon[] = updatePolygonAndMap(
      polygonPositionsArray,
      mapInstance
    );
    setAddedPolygon(polygonArray);
  }, [mapInstance, polygonPositionsArray]);
  return (
    <Map
      defaultCenter={polygonPositionsArray?.[0]?.[0] ?? defaultPosition}
      defaultZoom={12}
      gestureHandling="greedy"
      mapId={GOOGLE_MAP_ID}
      streetViewControl={false}
      mapTypeControl={false}
    ></Map>
  );
};

export default React.memo(GridMap);
